import React, {FC, useCallback, useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
// custom
import logo from '../../../assets/img/card-failure.png'; 
import NavbarUser from '../../../components/navbar/Navbar.user';
import './payment.page.css';
import { useSelector } from 'react-redux';
import { IUserState } from '../../../common/state/profile/user';
import { retrieveLocalStorageItem } from '../../../common/helpers/LocalStorage';
import { retrieveSubscriptionDetails, updateSubscriptionStatusById } from '../../../common/async/AsyncCalls';
import { ISubscriptionResponse } from '../../../common/state/subscriptions/subscription';
import { toast } from 'react-toastify';

const PaymentFailureView: FC = () => {
    // states
    const token = useSelector(({user} : {user: IUserState}) => user.token);
    const subscriptionId = retrieveLocalStorageItem('subscription');

    // lifecycle
    const triggerSalesCompleteEmails = useCallback(async()=>{
        if (!token || token === '' || !subscriptionId || subscriptionId === '') return ;
        try {
            const subscriptionResponse = await retrieveSubscriptionDetails(token, subscriptionId);
            const subscriptionDetails: ISubscriptionResponse = subscriptionResponse?.data as ISubscriptionResponse;
            const triggerEmailList = [
                updateSubscriptionStatusById(token, subscriptionId, 'failure'),                
            ];
            await Promise.all(triggerEmailList);
            toast(`Subscription updated!`);
        } catch (err) {
             console.log('Error - updating email and subscription: ', err);
        } 
    },[token, subscriptionId]);

    useEffect(()=>{
        // #1. Update subscription as failure
        triggerSalesCompleteEmails();

        // #2. Remove the parameters from the URL
        setTimeout(()=>{
            let url = window.location.href;
            let newUrl = url.replace(/\?.*/, '');                        
            window.history.replaceState({}, '', newUrl)},3000);
    },[]);
    return <React.Fragment>        
        <NavbarUser />
        <div
            className="flex flex-col items-center justify-center h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
            <div className="flex flex-col items-center justify-center max-w-md overflow-hidden bg-gray-100 rounded shadow-lg fadeIn slideInUp">
                <img className="w-1/2 mt-6" src={logo} alt="Sunset in the mountains" />
                <div className="flex flex-col items-center justify-center px-6 py-4">
                    <div className="mb-2 text-xl font-bold text-blue-800">Oops, something went wrong!</div>
                    <p className="mb-4 text-gray-700 dartext-base">
                        There seems to be a problem registering for the conference
                    </p>
                    <p className="mb-4 text-sm text-gray-700 dartext-base">
                        Please try again or reach out to our team for any clarification
                    </p>
                </div>
                <div className="px-6 pt-4 pb-2">
                    <Link to="/profile/events" className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-100 rounded-full bg-secondary-500">Try Again</Link>
                    <Link to="/profile/contact" className="inline-block px-3 py-1 mb-2 mr-2 text-sm font-semibold text-gray-100 rounded-full bg-secondary-500">Contact Us</Link>                                   
                </div>
            </div>
        </div>
    </React.Fragment>
};

export default PaymentFailureView;